import { AutoComplete, Form } from 'antd';
import { useDebounceFn } from 'ahooks';
import { OrderHistorySearchGroupEnum } from 'domains/orderDomain';
import { JobWorkspaceFilterTypeEnum } from 'domains/workspaceDomain';
import { OptionData } from 'rc-select/lib/interface';
import { useEffect, useState } from 'react';
import workspaceService from 'services/jobService';
import { DEBOUNCE_TIME } from 'utils/constants';

const LIMIT_LEN = 5;

export type BuyerOrderHistoryFilterParams = {
  jobOrOrderNumber?: string;
  orderId?: string;
};

type Props = {
  displayTotal?: number;
  total?: number;
  initialOrderId?: string;
  searchGroup?: OrderHistorySearchGroupEnum;
  filterType: JobWorkspaceFilterTypeEnum;
  callback: (filter: BuyerOrderHistoryFilterParams) => void;
};

const BuyerOrderHistoryFilter = ({
  displayTotal = 0,
  total = 0,
  initialOrderId,
  searchGroup,
  filterType,
  callback,
}: Props) => {
  const [options, setOptions] = useState<OptionData[]>([]);
  const [filterForm] = Form.useForm();

  const { run: runSearchJobOrOrderNumber } = useDebounceFn(
    async (prefix: string) => {
      const result = await workspaceService.getJobListFilterJobNumber({
        limit: LIMIT_LEN,
        prefix,
        searchGroup,
        filterType,
      });
      setOptions(result);
    },
    { wait: DEBOUNCE_TIME }
  );

  const { run: runFilterJobOrOrderNumber } = useDebounceFn(
    (jobOrOrderNumber?: string) => {
      callback({
        jobOrOrderNumber: jobOrOrderNumber || undefined,
        orderId: undefined,
      });
    },
    { wait: DEBOUNCE_TIME }
  );

  useEffect(() => {
    if (!initialOrderId) {
      return;
    }
    filterForm.setFieldsValue({ jobOrOrderNumber: initialOrderId });
    callback({ orderId: initialOrderId, jobOrOrderNumber: undefined });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialOrderId]);

  return (
    <div className="buyer-order-history-filter">
      <div className="buyer-order-history-filter__selector">
        <Form form={filterForm} layout="inline">
          <div className="form-item-wrapper">
            <div className="filter-label">Job ID or Order ID:</div>
            <Form.Item name="jobOrOrderNumber">
              <AutoComplete
                allowClear={true}
                options={options}
                placeholder="Job ID or Order ID"
                onSearch={runSearchJobOrOrderNumber}
                onSelect={(value) => {
                  callback({ jobOrOrderNumber: value, orderId: undefined });
                }}
                onChange={(value) => {
                  runFilterJobOrOrderNumber(value);
                }}
              />
            </Form.Item>
          </div>
        </Form>
      </div>
      <div className="buyer-order-history-filter__result">
        <p>
          <span>Showing </span>
          {displayTotal}
          <span> of </span>
          {total}
          <span> Total Orders</span>
        </p>
      </div>
    </div>
  );
};

export default BuyerOrderHistoryFilter;
